import React from 'react'
import { WingieMobileAppBanner } from '@enuygun/frontend-components'
import { useDeviceType } from 'hooks/useDeviceType'

const BannerWingie = ({ isTablet: isTabletProp }: { isTablet?: boolean }) => {
  const { isTablet: isTabletDevice } = useDeviceType()
  const isTablet = isTabletProp || isTabletDevice

  return (
    <div style={{ marginTop: 40 , marginBottom: 40 }}>
      <WingieMobileAppBanner dataTestId="wingie-homepage-app-banner" isTablet={isTablet} />
    </div>
  )
}

export default BannerWingie
